import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

async function resetPassword(payload) {
  const response = await apiClient.post(
    "/api/v1/auth/users/reset_password_confirm/",
    payload
  );
  return response.data;
}

function useResetPassword() {
  return useMutation({ mutationFn: resetPassword });
}

export { useResetPassword };
